import React, { useState, useEffect, useRef } from "react";
import { logo, profileAvatar } from "./ImageList";
import { NavLink, useNavigate } from "react-router-dom";
import baseURL from "./baseURL";
import stringsoflanguages from "./stringsoflanguages";

export default function Header() {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const dropdownRef = useRef(null);
    const userDropdownRef = useRef(null);
    const menuIconRef = useRef(null);
    const userInfoRef = useRef(null);
    const [userID, setUserID] = useState(null);
    const [userFName, setUserFName] = useState(null);
    const [userLName, setUserLName] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [userPicture, setUserPicture] = useState(null);
    const [notifCount, setNotifCount] = useState(0);
    const [pushFlag, setPushFlag] = useState(false);
    const [availableListingCount, setAvailableListingCount] = useState(
        Number(localStorage.getItem('available_listing_count') || 0)
    );
    /** `subscription_check` API `response.flag`: 0 = not subscribed (show premium URL modal), 1 = subscribed → premium home */
    const [subscriptionCheck, setSubscriptionCheck] = useState(() => {
        const f = localStorage.getItem('subscriptionFlag');
        if (f === null || f === '') return null;
        const n = Number(f);
        return Number.isNaN(n) ? null : n;
    });
    const [paidURL, setPaidURL] = useState('');
    const [isPremiumInfoModalOpen, setIsPremiumInfoModalOpen] = useState(false);
    // Close dropdown when clicking outside
    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        const fname = localStorage.getItem('user_fname');
        setUserFName(fname);
        const lname = localStorage.getItem('user_lname');
        setUserLName(lname);
        const userEmail = localStorage.getItem('user_email');
        setUserEmail(userEmail);
        const userPicture = localStorage.getItem('user_picture');
        setUserPicture(userPicture);

        const handleProfileImageUpdated = () => {
            const latest = localStorage.getItem('user_picture');
            if (latest) {
                const withTs = latest + (latest.includes('?') ? '&' : '?') + 't=' + Date.now();
                setUserPicture(withTs);
            } else {
                setUserPicture(profileAvatar);
            }
        };
        const handleAvailableListingCountUpdated = (event) => {
            const nextCount = Number(event?.detail?.count ?? localStorage.getItem('available_listing_count') ?? 0);
            setAvailableListingCount(Number.isNaN(nextCount) ? 0 : nextCount);
        };
        const handleWindowFocus = () => {
            const nextCount = Number(localStorage.getItem('available_listing_count') || 0);
            setAvailableListingCount(Number.isNaN(nextCount) ? 0 : nextCount);
        };
        window.addEventListener('profileImageUpdated', handleProfileImageUpdated);
        window.addEventListener('availableListingCountUpdated', handleAvailableListingCountUpdated);
        window.addEventListener('focus', handleWindowFocus);


        fetchNotificationsCount(userid);
        fetchSubscription(userid);
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                menuIconRef.current &&
                !menuIconRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false);
            }
            if (
                userDropdownRef.current &&
                !userDropdownRef.current.contains(event.target) &&
                userInfoRef.current &&
                !userInfoRef.current.contains(event.target)
            ) {
                setIsUserDropdownOpen(false);
            }
        };

        if (isDropdownOpen || isUserDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('profileImageUpdated', handleProfileImageUpdated);
            window.removeEventListener('availableListingCountUpdated', handleAvailableListingCountUpdated);
            window.removeEventListener('focus', handleWindowFocus);
        };
    }, [isDropdownOpen, isUserDropdownOpen]);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const toggleUserDropdown = () => {
        setIsUserDropdownOpen(!isUserDropdownOpen);
    };

    const handleLogoutClick = () => {
        setIsDropdownOpen(false);
        setIsLogoutModalOpen(true);
    };

    const handleLogoutConfirm = () => {
        localStorage.removeItem('user_id');
        // localStorage.removeItem('agentKey');
        setIsLogoutModalOpen(false);
        navigate('/');
    };

    const handleLogoutCancel = () => {
        setIsLogoutModalOpen(false);
    };

    const isPremiumSubscribed =
        subscriptionCheck === 1 || subscriptionCheck === '1';
    const isPremiumNotSubscribed =
        subscriptionCheck === 0 || subscriptionCheck === '0';

    function handlePremiumIconClick() {
        if (isPremiumSubscribed) {
            navigate('/premium-home');
            return;
        }
        if (isPremiumNotSubscribed) {
            setIsPremiumInfoModalOpen(true);
            return;
        }
        navigate('/premium-home');
    }

    function handlePremiumInfoModalYes() {
        if (paidURL) {
            window.open(paidURL, '_blank', 'noopener,noreferrer');
        }
        setIsPremiumInfoModalOpen(false);
    }

    function handlePremiumInfoModalNo() {
        setIsPremiumInfoModalOpen(false);
    }

    function fetchNotificationsCount(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + "/users/check_notfications_count", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response;
                // console.log('fetchNotificationsCountApi...')
                // console.log(responseJson)
                setNotifCount(result.notification_count);
                setPushFlag(result.push_flag == 0 ? false : true);
                // if (result.push_flag == 1) {
                //     //this.notificationAlert(result.notification_count)
                //     //   this.startShake()
                // }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function fetchSubscription(userid) {
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/users/subscription_check', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson?.server?.result_code === 200) {
                    const res = responseJson.response;
                    const flag = res?.flag;
                    setSubscriptionCheck(flag);
                    const url = res?.paid_url ? String(res.paid_url) : 'https://google.com';
                    setPaidURL(url);
                    if (flag !== undefined && flag !== null) {
                        localStorage.setItem('subscriptionFlag', String(flag));
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <div className="header-left">
                                <NavLink
                                    to="/home"
                                    style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}
                                    aria-label={stringsoflanguages.home}
                                >
                                    <img src={logo} alt="Logo" className="img-fluid" />
                                </NavLink>
                            </div>
                            <div className="header-center">
                                <ul className="nav nav-pills d-flex justify-content-center align-items-center">
                                    <li className="nav-item">
                                        <NavLink
                                            to="/home"
                                            className={({ isActive }) =>
                                                `nav-link ${isActive ? "active" : ""}`
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M18.7724 6.94691L13.8352 2.86477C12.1721 1.48974 9.82785 1.48974 8.16477 2.86477L3.22755 6.94691C2.33804 7.68237 1.83333 8.79746 1.83333 9.96094V16.3268C1.83333 18.394 3.42297 20.1668 5.49999 20.1668H7.33333C8.34585 20.1668 9.16666 19.346 9.16666 18.3335V15.3523C9.16666 14.1904 10.0394 13.3456 11 13.3456C11.9606 13.3456 12.8333 14.1904 12.8333 15.3523V18.3335C12.8333 19.346 13.6541 20.1668 14.6667 20.1668H16.5C18.5771 20.1668 20.1667 18.394 20.1667 16.3268V9.96094C20.1667 8.79747 19.6619 7.68237 18.7724 6.94691Z"
                                                    fill="#000000"
                                                />
                                            </svg>
                                            {stringsoflanguages.home}
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to="/news"
                                            className={({ isActive }) =>
                                                `nav-link ${isActive ? "active" : ""}`
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <path
                                                    d="M5.45834 5.18604H2.40702C1.8394 5.18604 1.375 5.65045 1.375 6.21805V11.2852C1.375 11.8529 1.8394 12.3173 2.40702 12.3173H5.45834V5.18604Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M17.1717 2.37588C16.7893 2.18831 16.3431 2.26325 16.0296 2.541C13.9372 4.25025 11.2519 5.19432 8.5544 5.18639C8.5544 5.1864 6.14636 5.1864 6.14636 5.1864V12.3176H8.5544C11.2665 12.3063 13.9229 13.2573 16.0469 14.9768C16.6826 15.5495 17.789 15.0601 17.76 14.1959C17.76 14.1959 17.76 3.30814 17.76 3.30814C17.76 2.90564 17.5364 2.54788 17.1717 2.37588Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M18.448 6.0498V11.4507C21.3515 10.7928 21.3499 6.7068 18.448 6.0498Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M7.63935 13.0054H3.62137L6.28397 18.8982C6.511 19.4004 7.01326 19.7273 7.5671 19.7273C8.46166 19.751 9.17893 18.8244 8.92935 17.9625L7.63935 13.0054Z"
                                                    fill="black"
                                                />
                                            </svg>
                                            {stringsoflanguages.news}
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to="/feed"
                                            className={({ isActive }) =>
                                                `nav-link header-feed-nav-link ${isActive ? "active" : ""}`
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <path
                                                    d="M3.8261 16.2607C3.02886 16.2607 2.35145 16.5398 1.7933 17.0977C1.23551 17.6555 0.956482 18.3331 0.956482 19.1303C0.956482 19.9277 1.23525 20.6051 1.7933 21.1629C2.35145 21.7208 3.02907 21.9999 3.8261 21.9999C4.62323 21.9999 5.30069 21.7208 5.85875 21.1629C6.41659 20.6051 6.69561 19.9277 6.69561 19.1303C6.69561 18.3331 6.41659 17.6555 5.85875 17.0977C5.30085 16.5398 4.62339 16.2607 3.8261 16.2607Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M10.4299 12.5245C9.30418 11.3887 8.01419 10.4845 6.55975 9.81209C5.10531 9.13943 3.58106 8.73839 1.98731 8.60889H1.91273C1.65371 8.60889 1.4395 8.69364 1.27029 8.86298C1.061 9.04211 0.956482 9.27642 0.956482 9.56532V11.5829C0.956482 11.832 1.0386 12.0462 1.20288 12.2257C1.36722 12.4052 1.5739 12.5048 1.82297 12.5245C4.10411 12.7438 6.05413 13.6632 7.67279 15.2821C9.29157 16.9009 10.2106 18.8515 10.4297 21.133C10.4497 21.3823 10.5493 21.589 10.7287 21.7531C10.908 21.9179 11.1221 22.0002 11.3711 22.0002H13.3884C13.6772 22.0002 13.9112 21.8958 14.0905 21.6863C14.28 21.4868 14.3646 21.2476 14.345 20.9687C14.2154 19.3749 13.8143 17.8502 13.142 16.3956C12.4697 14.9408 11.5655 13.6506 10.4299 12.5245Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M20.1224 13.1168C19.008 10.6221 17.4769 8.40611 15.5293 6.46859C13.5919 4.52066 11.3762 2.98953 8.88156 1.87492C6.38717 0.76053 3.77551 0.135393 1.04659 0H0.999803C0.72899 0 0.499874 0.093746 0.312346 0.281293C0.104134 0.468621 0 0.708376 0 1.00007V3.23427C0 3.49476 0.0912195 3.72117 0.273385 3.91391C0.455605 4.10671 0.676841 4.20812 0.937257 4.21874C3.17665 4.35435 5.30392 4.88574 7.31934 5.81275C9.33471 6.73981 11.0845 7.94554 12.5687 9.4296C14.0526 10.9139 15.2582 12.664 16.1851 14.6795C17.1121 16.6954 17.6384 18.8226 17.7632 21.0621C17.7739 21.3228 17.8752 21.5442 18.0677 21.7264C18.2605 21.9086 18.4924 22 18.7632 22H20.9971C21.2888 22 21.5279 21.8959 21.7158 21.6872C21.9242 21.479 22.0177 21.2344 21.9973 20.9531C21.862 18.2237 21.2367 15.6118 20.1224 13.1168Z"
                                                    fill="black"
                                                />
                                            </svg>
                                            {stringsoflanguages.feed}
                                            {availableListingCount > 0 && (
                                                <span className="header-feed-count">{availableListingCount}</span>
                                            )}
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to="/listing-layout"
                                            className={({ isActive }) =>
                                                `nav-link ${isActive ? "active" : ""}`
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <path
                                                    d="M19.7083 9.99183V3.7585C19.7083 2.3835 19.1217 1.8335 17.6642 1.8335H13.9608C12.5033 1.8335 11.9167 2.3835 11.9167 3.7585V9.99183C11.9167 11.3668 12.5033 11.9168 13.9608 11.9168H17.6642C19.1217 11.9168 19.7083 11.3668 19.7083 9.99183Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M10.0833 12.0085V18.2418C10.0833 19.6168 9.49666 20.1668 8.03916 20.1668H4.33582C2.87832 20.1668 2.29166 19.6168 2.29166 18.2418V12.0085C2.29166 10.6335 2.87832 10.0835 4.33582 10.0835H8.03916C9.49666 10.0835 10.0833 10.6335 10.0833 12.0085Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M19.7083 18.2417V15.675C19.7083 14.3 19.1217 13.75 17.6642 13.75H13.9608C12.5033 13.75 11.9167 14.3 11.9167 15.675V18.2417C11.9167 19.6167 12.5033 20.1667 13.9608 20.1667H17.6642C19.1217 20.1667 19.7083 19.6167 19.7083 18.2417Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M10.0833 6.32516V3.7585C10.0833 2.3835 9.49666 1.8335 8.03916 1.8335H4.33582C2.87832 1.8335 2.29166 2.3835 2.29166 3.7585V6.32516C2.29166 7.70016 2.87832 8.25016 4.33582 8.25016H8.03916C9.49666 8.25016 10.0833 7.70016 10.0833 6.32516Z"
                                                    fill="black"
                                                />
                                            </svg>
                                            {stringsoflanguages.listingLayout}
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to="/profile"
                                            className={({ isActive }) =>
                                                `nav-link ${isActive ? "active" : ""}`
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 22 22"
                                                fill="none"
                                            >
                                                <path
                                                    d="M11 10.8131C13.4923 10.8131 15.5128 8.80294 15.5128 6.32329C15.5128 3.84365 13.4923 1.8335 11 1.8335C8.50764 1.8335 6.48718 3.84365 6.48718 6.32329C6.48718 8.80294 8.50764 10.8131 11 10.8131Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M13.3504 12.6841H8.64956C5.92307 12.6841 3.66666 14.9291 3.66666 17.6416C3.66666 18.2964 3.94871 18.8576 4.51281 19.1382C5.35896 19.6059 7.23931 20.167 11 20.167C14.7607 20.167 16.641 19.6059 17.4871 19.1382C17.9572 18.8576 18.3333 18.2964 18.3333 17.6416C18.3333 14.8355 16.0769 12.6841 13.3504 12.6841Z"
                                                    fill="black"
                                                />
                                            </svg>
                                            {stringsoflanguages.profile}
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="header-right">

                                {/* Notification Bell Icon */}
                                <div className="header-icon-wrapper d-flex align-items-center gap-2">
                                    <div className="profile-menu-icon" ref={menuIconRef} onClick={toggleDropdown}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z" fill="white" />
                                            <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="white" />
                                            <path d="M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z" fill="white" />
                                        </svg>

                                        {/* Dropdown Menu */}
                                        {isDropdownOpen && (
                                            <div className="profile-dropdown liquidGlass-wrapper dock" ref={dropdownRef}>
                                                <div className="liquidGlass-effect"></div>
                                                <div className="liquidGlass-shine"></div>

                                                <div className="dropdown-menu-content">
                                                    <div className="dropdown-menu-item" onClick={handleLogoutClick}>
                                                        <svg fill="none" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_9208320"><path clip-rule="evenodd" d="m12 2c.5523 0 1 .44772 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1v-10c0-.55228.4477-1 1-1zm-3.13439 3.56953c.27654.47806.11318 1.08979-.36488 1.36633-2.09492 1.21185-3.50073 3.47444-3.50073 6.06414 0 3.866 3.13401 7 7 7 3.866 0 7-3.134 7-7 0-2.5897-1.4058-4.85229-3.5007-6.06414-.4781-.27654-.6414-.88827-.3649-1.36633s.8883-.64142 1.3663-.36488c2.6875 1.55463 4.4993 4.46282 4.4993 7.79535 0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9 0-3.33253 1.81178-6.24072 4.49927-7.79535.47806-.27654 1.08979-.11318 1.36634.36488z" fill="rgb(0,0,0)" fill-rule="evenodd"></path></svg>
                                                        <span>Log out</span>
                                                    </div>
                                                    <div className="dropdown-menu-item" onClick={() => navigate('/profile')}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M11.9996 1.02747C8.9748 1.02747 6.51384 3.48843 6.51384 6.51318V9.94395H5.82847C4.5049 9.94395 3.42847 11.0206 3.42847 12.3439V20.5725C3.42847 21.8959 4.5049 22.9725 5.82847 22.9725H18.1713C19.4945 22.9725 20.5713 21.8959 20.5713 20.5725V12.3439C20.5713 11.0206 19.4945 9.94395 18.1713 9.94395H17.4853V6.51318C17.4853 3.48843 15.0243 1.02747 11.9996 1.02747ZM8.57098 6.51318C8.57098 4.6228 10.1092 3.08461 11.9996 3.08461C13.8899 3.08461 15.4281 4.6228 15.4281 6.51318V9.94395H8.57098V6.51318ZM8.22847 17.4937C7.65926 17.4937 7.1999 17.0343 7.1999 16.4651C7.1999 15.8959 7.65926 15.4365 8.22847 15.4365C8.79734 15.4365 9.25704 15.8959 9.25704 16.4651C9.25704 17.0343 8.79734 17.4937 8.22847 17.4937ZM11.9999 17.4937C11.4307 17.4937 10.9713 17.0343 10.9713 16.4651C10.9713 15.8959 11.4307 15.4365 11.9999 15.4365C12.5688 15.4365 13.0285 15.8959 13.0285 16.4651C13.0285 17.0343 12.5688 17.4937 11.9999 17.4937ZM15.7713 17.4937C15.2021 17.4937 14.7428 17.0343 14.7428 16.4651C14.7428 15.8959 15.2021 15.4365 15.7713 15.4365C16.3402 15.4365 16.7999 15.8959 16.7999 16.4651C16.7999 17.0343 16.3402 17.4937 15.7713 17.4937Z" fill="white" />
                                                        </svg>
                                                        <span>Change Password</span>
                                                    </div>

                                                    <div className="dropdown-menu-item">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <g clip-path="url(#clip0_186_976)">
                                                                <path d="M23.7887 4.76819L16.51 12L23.7887 19.2318C23.9203 18.9568 24.0001 18.6528 24.0001 18.3281V5.67189C24.0001 5.34719 23.9203 5.0432 23.7887 4.76819Z" fill="white" />
                                                                <path d="M21.8905 3.5625H2.10927C1.78457 3.5625 1.48058 3.64233 1.20557 3.77391L10.5085 13.03C11.3311 13.8525 12.6687 13.8525 13.4913 13.03L22.7942 3.77391C22.5192 3.64233 22.2152 3.5625 21.8905 3.5625Z" fill="white" />
                                                                <path d="M0.211406 4.76819C0.0798281 5.0432 0 5.34719 0 5.67189V18.3281C0 18.6528 0.0798281 18.9569 0.211406 19.2318L7.49011 12L0.211406 4.76819Z" fill="white" />
                                                                <path d="M15.5155 12.9943L14.4855 14.0242C13.115 15.3948 10.8848 15.3948 9.51421 14.0242L8.48427 12.9943L1.20557 20.2261C1.48058 20.3577 1.78457 20.4375 2.10927 20.4375H21.8905C22.2152 20.4375 22.5192 20.3577 22.7942 20.2261L15.5155 12.9943Z" fill="white" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_186_976">
                                                                    <rect width="24" height="24" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span>Change Email Id</span>
                                                    </div>

                                                    <div className="dropdown-menu-item">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M23.1812 8.06328L17.7485 2.63052C17.3002 2.18225 16.8455 1.95496 16.3971 1.95496C15.7814 1.95496 15.0625 2.42324 15.0625 3.74305V5.5926C11.1154 5.76463 7.42941 7.38336 4.61803 10.1946C1.64034 13.1721 0.00028125 17.1309 0 21.3419C0 21.6444 0.1935 21.9131 0.480469 22.0089C0.553734 22.0333 0.628734 22.0451 0.703031 22.0451C0.919922 22.0451 1.12988 21.9444 1.26525 21.7642C4.58489 17.3455 9.5827 14.7342 15.0625 14.528V16.3491C15.0625 17.6688 15.7814 18.1372 16.3971 18.1372H16.3972C16.8456 18.1372 17.3003 17.9099 17.7485 17.4617L23.1812 12.0288C23.7092 11.501 24 10.7968 24 10.0461C24 9.29544 23.7092 8.59124 23.1812 8.06328Z" fill="white" />
                                                        </svg>
                                                        <span>Share</span>
                                                    </div>

                                                    <div className="dropdown-menu-item">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <g clip-path="url(#clip0_186_995)">
                                                                <path d="M13.1325 19.2225C13.1325 17.5959 13.7658 16.0664 14.9161 14.9161C16.0664 13.7658 17.5955 13.1325 19.2225 13.1325C20.558 13.1325 21.8278 13.56 22.8764 14.3494C22.9345 13.5 22.9706 12.5498 22.972 11.4862C22.9692 8.81109 22.7447 6.85219 22.5052 5.41266C22.0861 3.04078 19.9317 0.886406 17.5598 0.467344C16.1203 0.227344 14.1614 0.0028125 11.4858 0C8.81062 0.0028125 6.85125 0.227344 5.41172 0.466875C3.04031 0.885937 0.885937 3.04031 0.466875 5.41219C0.227344 6.85172 0.00328125 8.81062 0 11.4858C0.00328125 14.1609 0.227344 16.1203 0.466875 17.5598C0.885937 19.9317 3.04031 22.0861 5.41219 22.5052C6.85172 22.7447 8.81062 22.9687 11.4862 22.972C12.5498 22.9706 13.5 22.9345 14.3494 22.8764C13.56 21.8278 13.1325 20.5584 13.1325 19.2225ZM5.81062 5.55094H17.1614C17.8955 5.55094 18.4908 6.14625 18.4908 6.88031C18.4908 7.61437 17.8955 8.20969 17.1614 8.20969H5.81062C5.07656 8.20969 4.48125 7.61437 4.48125 6.88031C4.48125 6.14625 5.07656 5.55094 5.81062 5.55094ZM5.81062 13.7611C5.07656 13.7611 4.48125 13.1658 4.48125 12.4317C4.48125 11.6977 5.07656 11.1023 5.81062 11.1023H12.4739C13.208 11.1023 13.8033 11.6977 13.8033 12.4317C13.8033 13.1658 13.208 13.7611 12.4739 13.7611H5.81062Z" fill="white" />
                                                                <path d="M19.2226 14.4449C16.584 14.4449 14.4451 16.5839 14.4451 19.2224C14.4451 21.861 16.584 23.9999 19.2226 23.9999C21.8612 23.9999 24.0001 21.861 24.0001 19.2224C24.0001 16.5839 21.8612 14.4449 19.2226 14.4449ZM20.1132 21.5929C20.1132 22.0846 19.7143 22.4835 19.2226 22.4835C18.7308 22.4835 18.3319 22.0846 18.3319 21.5929V19.2431C18.3319 18.7514 18.7308 18.3524 19.2226 18.3524C19.7143 18.3524 20.1132 18.7514 20.1132 19.2431V21.5929ZM20.0766 17.3367C20.0438 17.5223 19.8751 17.691 19.6894 17.7239C19.5769 17.7426 19.4232 17.7599 19.2137 17.7604C19.0041 17.7604 18.8508 17.7426 18.7379 17.7239C18.5523 17.691 18.3835 17.5223 18.3507 17.3367C18.3319 17.2242 18.3146 17.0704 18.3141 16.8609C18.3141 16.6514 18.3319 16.4981 18.3507 16.3851C18.3835 16.1995 18.5523 16.0307 18.7379 15.9979C18.8504 15.9792 19.0041 15.9618 19.2137 15.9614C19.4232 15.9614 19.5765 15.9792 19.6894 15.9979C19.8751 16.0307 20.0438 16.1995 20.0766 16.3851C20.0954 16.4976 20.1127 16.6514 20.1132 16.8609C20.1132 17.0704 20.0954 17.2237 20.0766 17.3367Z" fill="white" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_186_995">
                                                                    <rect width="24" height="24" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span>Terms & Conditions</span>
                                                    </div>


                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="header-icon bell-icon" style={{ position: 'relative' }} onClick={() => navigate('/notifications')}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M20.6288 15.9989C20.551 15.9052 20.4745 15.8114 20.3995 15.7209C19.3683 14.4736 18.7444 13.7208 18.7444 10.1897C18.7444 8.36156 18.307 6.86156 17.445 5.73656C16.8094 4.90547 15.9502 4.275 14.8177 3.80906C14.8031 3.80096 14.7901 3.79032 14.7792 3.77766C14.3719 2.41359 13.2572 1.5 12 1.5C10.7428 1.5 9.62861 2.41359 9.22127 3.77625C9.2104 3.78845 9.19756 3.79875 9.1833 3.80672C6.54049 4.89469 5.25611 6.98203 5.25611 10.1883C5.25611 13.7208 4.63314 14.4736 3.60095 15.7195C3.52595 15.81 3.44955 15.9019 3.37174 15.9975C3.17074 16.2399 3.04339 16.5348 3.00476 16.8473C2.96613 17.1598 3.01784 17.4769 3.15377 17.7609C3.44299 18.3703 4.05939 18.7486 4.76299 18.7486H19.2422C19.9425 18.7486 20.5547 18.3708 20.8449 17.7642C20.9814 17.4801 21.0336 17.1628 20.9953 16.8499C20.957 16.537 20.8298 16.2417 20.6288 15.9989Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M12 22.5C12.6773 22.4995 13.3419 22.3156 13.9232 21.9679C14.5046 21.6202 14.9809 21.1217 15.3019 20.5252C15.317 20.4966 15.3244 20.4646 15.3235 20.4322C15.3226 20.3999 15.3134 20.3684 15.2967 20.3407C15.28 20.313 15.2564 20.2901 15.2282 20.2742C15.2001 20.2583 15.1683 20.25 15.1359 20.25H8.86498C8.8326 20.2499 8.80074 20.2582 8.77251 20.274C8.74428 20.2899 8.72063 20.3128 8.70388 20.3405C8.68712 20.3682 8.67783 20.3997 8.6769 20.4321C8.67597 20.4645 8.68343 20.4965 8.69857 20.5252C9.01945 21.1216 9.49575 21.6201 10.077 21.9678C10.6582 22.3155 11.3227 22.4994 12 22.5Z"
                                                fill="#E1730B"
                                            />
                                        </svg>
                                        {(pushFlag === 1 || notifCount > 0) && (
                                            <span className="notification-badge"></span>
                                        )}
                                    </div>

                                    {/* Diamond Icon */}
                                    <div
                                        className="header-icon"
                                        onClick={handlePremiumIconClick}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handlePremiumIconClick();
                                            }
                                        }}
                                        aria-label="Premium"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="26"
                                            height="26"
                                            viewBox="0 0 26 26"
                                            fill="none"
                                        >
                                            <path
                                                d="M7.2868 9.91064L10.7796 22.0513L0 9.91064H7.2868Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M7.42024 8.38808H0L6.86669 2.01175C7.00926 1.87014 7.20204 1.79102 7.403 1.79102H11.2271L7.42024 8.38808Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M9.1778 8.38811L12.9841 1.7915L16.7905 8.38811H9.1778Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M17.098 9.91064L12.9842 24.2091L8.87036 9.91064H17.098Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M18.5481 8.38813L14.7412 1.79102H19.0727C19.2843 1.79102 19.4857 1.87881 19.6298 2.03361L26 8.38813H18.5481Z"
                                                fill="#E1730B"
                                            />
                                            <path
                                                d="M25.9683 9.91064L15.1887 22.0513L18.6815 9.91064H25.9683Z"
                                                fill="#E1730B"
                                            />
                                        </svg>
                                    </div>

                                </div>

                                <div className="header-user-info-wrapper d-flex align-items-center gap-2" ref={userInfoRef} onClick={toggleUserDropdown} style={{ cursor: 'pointer' }}>
                                    {/* User Avatar */}
                                    <div className="header-avatar">
                                        <img src={userPicture} alt="User" />
                                    </div>

                                    {/* Greeting Text */}
                                    <div className="header-greeting">
                                        <p className="greeting-text">{stringsoflanguages.hey}</p>
                                        <p className="greeting-name">{localStorage.getItem('user_fname')}</p>
                                    </div>

                                    {/* User Dropdown Menu */}
                                    {isUserDropdownOpen && (
                                        <div className="profile-dropdown logout-drop liquidGlass-wrapper dock" ref={userDropdownRef}>
                                            <div className="liquidGlass-effect"></div>
                                            <div className="liquidGlass-shine"></div>

                                            <div className="dropdown-menu-content">
                                                <div className="dropdown-menu-item" onClick={handleLogoutClick}>
                                                    <svg fill="none" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_9208320"><path clipRule="evenodd" d="m12 2c.5523 0 1 .44772 1 1v10c0 .5523-.4477 1-1 1s-1-.4477-1-1v-10c0-.55228.4477-1 1-1zm-3.13439 3.56953c.27654.47806.11318 1.08979-.36488 1.36633-2.09492 1.21185-3.50073 3.47444-3.50073 6.06414 0 3.866 3.13401 7 7 7 3.866 0 7-3.134 7-7 0-2.5897-1.4058-4.85229-3.5007-6.06414-.4781-.27654-.6414-.88827-.3649-1.36633s.8883-.64142 1.3663-.36488c2.6875 1.55463 4.4993 4.46282 4.4993 7.79535 0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9 0-3.33253 1.81178-6.24072 4.49927-7.79535.47806-.27654 1.08979-.11318 1.36634.36488z" fill="rgb(0,0,0)" fillRule="evenodd"></path></svg>
                                                    <span>{stringsoflanguages.logout}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {isPremiumInfoModalOpen && (
                <>
                    <div
                        className="modal-overlay"
                        onClick={handlePremiumInfoModalNo}
                        role="presentation"
                    />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="premium-info-modal-title">
                        <h3
                            id="premium-info-modal-title"
                            style={{
                                margin: '0 0 15px 0',
                                fontSize: '20px',
                                fontWeight: '600',
                                color: '#fff',
                            }}
                        >
                            Get info about PREMIUM?
                        </h3>
                        <p
                            style={{
                                margin: '0 0 8px 0',
                                fontSize: '14px',
                                color: 'rgba(255,255,255,0.85)',
                            }}
                        >
                            Link:
                        </p>
                        <p
                            style={{
                                margin: '0 0 25px 0',
                                fontSize: '15px',
                                color: '#fff',
                                lineHeight: '1.5',
                                wordBreak: 'break-all',
                            }}
                        >
                            {paidURL || '—'}
                        </p>
                        <div className="btn-sec">
                            <button
                                type="button"
                                className="cancel-btn custom-btn"
                                onClick={handlePremiumInfoModalNo}
                            >
                                No
                            </button>
                            <button
                                type="button"
                                className="save-btn custom-btn"
                                onClick={handlePremiumInfoModalYes}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Logout confirmation */}
            {isLogoutModalOpen && (
                <>
                    <div
                        className="modal-overlay"
                        onClick={handleLogoutCancel}

                    />
                    <div
                        className="logout-modal"

                    >
                        <h3 style={{
                            margin: '0 0 15px 0',
                            fontSize: '20px',
                            fontWeight: '600',
                            color: '#fff'
                        }}>
                            Confirm Logout
                        </h3>
                        <p style={{
                            margin: '0 0 25px 0',
                            fontSize: '16px',
                            color: '#fff',
                            lineHeight: '1.5'
                        }}>
                            Are you sure you want to logout?
                        </p>
                        <div className='btn-sec'>
                            <button className='cancel-btn custom-btn'
                                onClick={handleLogoutCancel}

                            >
                                No
                            </button>
                            <button className='save-btn custom-btn'
                                onClick={handleLogoutConfirm}

                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* SVG Filter for glass effect */}
            <svg style={{ display: 'none' }}>
                <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5"
                        result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100"
                        lighting-color="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R"
                        yChannelSelector="G" />
                </filter>
            </svg>
        </>
    );
}

